import { Badge } from '@/platform/ui';

const StatusLabel = ({
    label = 'Geen',
    color = 'gray',
    rejectionReason = null,
}) => (
    <Badge color={color} title={rejectionReason || undefined}>
        {label}
    </Badge>
);

export default StatusLabel;
